<!--
 * @Descripttion: 商品详情
 * @Author: congz
 * @Date: 2020-06-04 11:22:40
 * @LastEditors: congz
 * @LastEditTime: 2020-10-28 12:05:31
-->

<template>
  <div id="details" v-if="productDetails">
    <!-- 品牌头部 -->
    <div class="brand-header">
      <div class="brand-header-bg"></div>
      <div class="brand-header-content">
        <p class="brand-header-title">{{ productDetails.name }}</p>
        <div class="brand-header-nav">
          <span class="nav-item" @click="goInfo">Overview</span>
          <span class="nav-divider">|</span>
          <span class="nav-item" @click="goParam">Parameter</span>
          <span class="nav-divider">|</span>
          <span class="nav-item">Reviews</span>
        </div>
      </div>
    </div>

    <!-- 主要内容 -->
    <div class="details-main">
      <!-- 左侧商品图片 -->
      <div class="details-gallery">
        <div class="gallery-card">
          <el-carousel height="520px" v-if="productPictures.length > 1">
            <el-carousel-item v-for="item in productPictures" :key="item.id">
              <img v-lazy="item.img_path" />
            </el-carousel-item>
          </el-carousel>
          <div v-if="productPictures.length == 1" class="single-img">
            <img :src="productPictures[0].img_path" />
          </div>
        </div>
      </div>

      <!-- 右侧内容区 -->
      <div class="details-content">
        <div class="content-card">
          <div class="product-badge">
            <span v-if="productDetails.price != productDetails.discount_price" class="badge-sale">SALE</span>
            <span class="badge-store">Self Operated</span>
            <span class="badge-view"><i class="el-icon-view"></i> {{ productDetails.view }}</span>
          </div>

          <h1 class="product-name">{{ productDetails.name }}</h1>
          <p class="product-info" v-if="productDetails.info">{{ productDetails.info }}</p>

          <div class="price-box">
            <div class="price-main">
              <span class="currency">₹</span>
              <span class="amount">{{ productDetails.discount_price }}</span>
            </div>
            <span v-show="productDetails.price != productDetails.discount_price" class="price-original">
              ₹{{ productDetails.price }}
            </span>
            <span v-show="productDetails.price != productDetails.discount_price" class="price-off">
              -{{ Math.round((1 - productDetails.discount_price / productDetails.price) * 100) }}%
            </span>
          </div>

          <!-- 商品属性 -->
          <div class="props-card" v-if="productProperties">
            <div class="props-row" v-for="(val, key) in productProperties" :key="key">
              <span class="props-key">{{ key }}</span>
              <span class="props-val">{{ val }}</span>
            </div>
          </div>

          <!-- 尺码选择 -->
          <div class="size-box" v-if="showSize">
            <span class="size-box-label">Size</span>
            <el-radio-group v-model="selectedSize" class="size-radio-group">
              <el-radio-button v-for="s in sizeOptions" :key="s" :label="s">{{ s }}</el-radio-button>
            </el-radio-group>
          </div>

          <!-- 按钮区 -->
          <div class="action-row">
            <el-button class="btn-cart" :disabled="dis" @click="addShoppingCart">
              <i class="el-icon-shopping-cart-2"></i> Add to Cart
            </el-button>
            <el-button class="btn-fav" @click="addFavorite">
              <i class="el-icon-star-off"></i> Favorite
            </el-button>
          </div>

          <!-- 服务承诺 -->
          <div class="service-row">
            <div class="service-item">
              <i class="el-icon-check"></i> Self Operated Mall
            </div>
            <div class="service-item">
              <i class="el-icon-check"></i> Fast Delivery
            </div>
            <div class="service-item">
              <i class="el-icon-check"></i> 7-Day Returns
            </div>
            <div class="service-item">
              <i class="el-icon-check"></i> Price Protection
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 商品详情Tab -->
    <div class="detail-imgs" v-for="item in imgs" :key="item.id">
      <img v-lazy="item.img_path" />
    </div>
  </div>
  <div class="not-found" v-else>
    <i class="el-icon-warning-outline"></i>
    <p>Unable to find the product</p>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import * as productsAPI from '@/api/products/'
import * as imgsAPI from '@/api/img/'
import * as favoritesAPI from '@/api/favorites/'
import * as cartsAPI from '@/api/carts/'
export default {
  data() {
    return {
      dis: false, // 控制“加入购物车按钮是否可用”
      productID: 0, // 商品id
      productDetails: '', // 商品详细信息
      productPictures: '', // 商品图片
      imgs: '', //商品概述图片
      infoImgs: '',
      paramImgs: '',
      select: 0,
      selectedSize: 'M', // 默认尺码
      sizeOptions: ['S', 'M', 'L', 'XL', 'XXL']
    }
  },
  // 通过路由获取商品id
  activated() {
    if (this.$route.query.productID != undefined) {
      this.productID = this.$route.query.productID
    }
  },
  computed: {
    showSize() {
      if (!this.productDetails || !this.productDetails.name) return true
      const name = this.productDetails.name.toLowerCase()
      const noSizeKeywords = [
        'sunglass', 'sunglasses', 'hat', 'cap', 'scarf', 'stole', 'hijab',
        'dupatta', 'socks', 'nakab', 'belt', 'wallet', 'bag', 'jewel',
        'necklace', 'earring', 'bangle', 'bracelet', 'watch'
      ]
      return !noSizeKeywords.some(k => name.includes(k))
    },
    productProperties() {
      if (!this.productDetails || !this.productDetails.properties) return null
      try {
        return JSON.parse(this.productDetails.properties)
      } catch (e) {
        return null
      }
    }
  },
  watch: {
    // 监听商品id的变化，请求后端获取商品数据
    productID: function() {
      this.load()
      //this.getDetailsPicture(val);
    }
  },
  methods: {
    ...mapActions(['unshiftShoppingCart', 'addShoppingCartNum']),
    // 获取商品详细信息
    load() {
      productsAPI.showProduct(this.productID).then(res => {
        this.productDetails = res.data
      })
      productsAPI.showPictures(this.productID).then(res => {
        this.productPictures = res.data
      })
      imgsAPI.showInfoImgs(this.productID).then(res => {
        this.infoImgs = res.data
        this.imgs = this.infoImgs
      })
      imgsAPI.showParamImgs(this.productID).then(res => {
        this.paramImgs = res.data
      })
    },
    goInfo() {
      this.showInfoImgs()
      document.getElementById('product-select').scrollIntoView()
    },
    goParam() {
      this.showParamImgs()
      document.getElementById('product-select').scrollIntoView()
    },
    showInfoImgs() {
      this.select = 0
      this.imgs = this.infoImgs
    },
    showParamImgs() {
      this.select = 1
      this.imgs = this.paramImgs
    },
    // 加入购物车
    addShoppingCart() {
      // 判断是否登录,没有登录则显示登录组件
      if (!this.$store.getters.getUser) {
        this.$router.push({ name: 'Login' })
        return
      }
      var form = {
        user_id: this.$store.getters.getUser.id,
        product_id: Number(this.productID),
        size: this.showSize ? this.selectedSize : ''
      }
      cartsAPI
        .postCart(form)
        .then(res => {
          switch (res.status) {
            case 200:
              //新加入购物车成功
              this.unshiftShoppingCart(res.data)
              this.notifySucceed('Add shopping cart successfully')
              break
            case 201:
              // 该商品已经在购物车，数量+1
              this.addShoppingCartNum(this.productID)
              this.notifySucceed('The product is already in the shopping cart, quantity+1')
              break
            case 202:
              // 商品数量达到限购数量
              this.dis = true
              this.notifyError('The product has reached the purchase limit quantity', res.msg)
              break
            case 20001:
              //token过期，需要重新登录
              this.loginExpired(res.msg)
              break
            default:
              this.notifyError('Adding shopping cart failed', res.msg)
          }
        })
        .catch(err => {
          this.notifyError('Adding shopping cart failed', err)
        })
    },
    addFavorite() {
      // 判断是否登录,没有登录则显示登录组件
      if (!this.$store.getters.getUser) {
        this.$router.push({ name: 'Login' })
        return
      }
      var form = {
        user_id: this.$store.getters.getUser.id,
        product_id: Number(this.productID)
      }
      favoritesAPI
        .postFavorite(form)
        .then(res => {
          if (res.status === 200) {
            this.notifySucceed('Favorite added successfully')
          } else if (res.status === 20001) {
            //token过期，需要重新登录
            this.loginExpired(res.msg)
          } else {
            this.notifyError('Add Favorite Failed', res.msg)
          }
        })
        .catch(err => {
          this.notifyError('Add Favorite Failed', err)
        })
    }
  },
  beforeRouteEnter(to, from, next) {
    // 添加背景色
    document
      .querySelector('body')
      .setAttribute('style', 'background-color:#ffffff')
    next()
  },
  beforeRouteLeave(to, from, next) {
    // 去除背景色
    document
      .querySelector('body')
      .setAttribute('style', 'background-color:#f5f5f5')
    next()
  }
}
</script>
<style scoped>
/* ===== 品牌头部 ===== */
#details .brand-header {
  position: relative;
  margin-top: 20px;
  margin-bottom: 30px;
  overflow: hidden;
}
#details .brand-header-bg {
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, #5a4b6c 0%, #4a3d5a 50%, #5a4b6c 100%);
}
#details .brand-header-content {
  position: relative;
  z-index: 1;
  max-width: 1225px;
  margin: 0 auto;
  padding: 20px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
#details .brand-header-title {
  font-size: 16px;
  color: #fff;
  font-weight: 600;
  max-width: 600px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
#details .brand-header-nav {
  display: flex;
  align-items: center;
  gap: 0;
}
#details .nav-item {
  color: rgba(255,255,255,0.75);
  font-size: 13px;
  cursor: pointer;
  padding: 4px 12px;
  border-radius: 20px;
  transition: all .2s;
}
#details .nav-item:hover {
  color: #fff;
  background: rgba(255,255,255,0.15);
}
#details .nav-divider {
  color: rgba(255,255,255,0.35);
  font-size: 14px;
}

/* ===== 主体区 ===== */
#details .details-main {
  max-width: 1225px;
  margin: 0 auto 30px;
  display: flex;
  gap: 30px;
  align-items: flex-start;
}

/* ===== 左侧图片 ===== */
#details .details-gallery {
  flex: 0 0 520px;
  position: sticky;
  top: 20px;
}
#details .gallery-card {
  background: #fff;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 18px 40px rgba(255, 95, 143, 0.08);
}
#details .gallery-card img {
  width: 100%;
  height: 520px;
  object-fit: cover;
  display: block;
}
#details .gallery-card .single-img img {
  height: 520px;
}
#details /deep/ .el-carousel__indicator .el-carousel__button {
  background-color: rgba(255, 95, 143, 0.4);
  width: 8px;
  height: 8px;
  border-radius: 50%;
}
#details /deep/ .el-carousel__indicator.is-active .el-carousel__button {
  background-color: #ff5f8f;
}

/* ===== 右侧内容卡片 ===== */
#details .details-content {
  flex: 1;
  min-width: 0;
}
#details .content-card {
  background: #fff;
  border-radius: 20px;
  padding: 30px 32px;
  box-shadow: 0 18px 40px rgba(255, 95, 143, 0.08);
}

/* 商品标签行 */
#details .product-badge {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 14px;
}
#details .badge-sale {
  background: linear-gradient(135deg, #ff5f8f, #e8517a);
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  padding: 3px 10px;
  border-radius: 4px;
  letter-spacing: 1px;
}
#details .badge-store {
  background: #fbf5f7;
  color: #ff5f8f;
  font-size: 11px;
  padding: 3px 10px;
  border-radius: 4px;
  font-weight: 500;
}
#details .badge-view {
  margin-left: auto;
  color: #b0a8b8;
  font-size: 13px;
}
#details .badge-view i {
  margin-right: 2px;
}

/* 商品名 */
#details .product-name {
  font-size: 22px;
  font-weight: 700;
  color: #2f2238;
  line-height: 1.4;
  margin: 0 0 8px;
}
#details .product-info {
  color: #8a7f97;
  font-size: 14px;
  line-height: 1.6;
  margin: 0 0 20px;
}

/* 价格区 */
#details .price-box {
  display: flex;
  align-items: baseline;
  gap: 12px;
  padding: 18px 0;
  border-top: 1px solid #f3eff5;
  border-bottom: 1px solid #f3eff5;
  margin-bottom: 20px;
}
#details .price-main {
  display: flex;
  align-items: baseline;
}
#details .price-main .currency {
  font-size: 18px;
  font-weight: 600;
  color: #ff5f8f;
}
#details .price-main .amount {
  font-size: 30px;
  font-weight: 700;
  color: #ff5f8f;
  line-height: 1;
}
#details .price-original {
  font-size: 16px;
  color: #b9afc5;
  text-decoration: line-through;
}
#details .price-off {
  font-size: 12px;
  font-weight: 700;
  color: #fff;
  background: #ff5f8f;
  padding: 2px 8px;
  border-radius: 4px;
}

/* 属性卡片 */
#details .props-card {
  background: #fbf5f7;
  border-radius: 14px;
  padding: 16px 20px;
  margin-bottom: 20px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px 24px;
}
#details .props-row {
  display: flex;
  justify-content: space-between;
  padding: 6px 0;
  border-bottom: 1px dashed #eadfd8;
}
#details .props-row:last-child,
#details .props-row:nth-last-child(2):nth-child(odd) {
  border-bottom: none;
}
#details .props-key {
  font-size: 13px;
  color: #8a7f97;
  text-transform: capitalize;
}
#details .props-val {
  font-size: 13px;
  color: #2f2238;
  font-weight: 500;
}

/* 尺码 */
#details .size-box {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 22px;
}
#details .size-box-label {
  font-size: 13px;
  font-weight: 600;
  color: #2f2238;
  text-transform: uppercase;
  letter-spacing: 1px;
}
#details .size-box /deep/ .el-radio-button__inner {
  border: 1px solid #e0d8e8;
  border-radius: 6px;
  padding: 7px 18px;
  font-size: 13px;
  font-weight: 500;
  color: #5a4b6c;
  background: #fff;
}
#details .size-box /deep/ .el-radio-button.is-active .el-radio-button__inner {
  background: #ff5f8f;
  border-color: #ff5f8f;
  color: #fff;
  box-shadow: 0 4px 12px rgba(255, 95, 143, 0.3);
}
#details .size-box /deep/ .el-radio-button__inner:hover {
  color: #ff5f8f;
  border-color: #ff5f8f;
}

/* 按钮 */
#details .action-row {
  display: flex;
  gap: 16px;
  margin-bottom: 22px;
}
#details .btn-cart {
  flex: 1;
  height: 50px;
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  border: none;
  border-radius: 30px;
  background: linear-gradient(135deg, #ff5f8f 0%, #e8517a 100%);
  box-shadow: 0 6px 20px rgba(255, 95, 143, 0.25);
  transition: all .2s;
}
#details .btn-cart:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 28px rgba(255, 95, 143, 0.35);
}
#details .btn-cart.is-disabled {
  background: #d5cddb;
  box-shadow: none;
  transform: none;
}
#details .btn-fav {
  width: 140px;
  height: 50px;
  font-size: 14px;
  font-weight: 500;
  color: #ff5f8f;
  border: 1.5px solid #ff5f8f;
  border-radius: 30px;
  background: #fff;
  transition: all .2s;
}
#details .btn-fav:hover {
  background: #fbf5f7;
  transform: translateY(-2px);
  box-shadow: 0 6px 18px rgba(255, 95, 143, 0.12);
}

/* 服务承诺 */
#details .service-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 20px;
  padding-top: 18px;
  border-top: 1px solid #f3eff5;
}
#details .service-item {
  font-size: 12px;
  color: #8a7f97;
  display: flex;
  align-items: center;
  gap: 4px;
}
#details .service-item i {
  color: #ff5f8f;
  font-size: 14px;
  font-weight: 700;
}

/* ===== 详情Tab ===== */
#details .detail-tabs {
  max-width: 1225px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  gap: 0;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 4px 20px rgba(255, 95, 143, 0.06);
  overflow: hidden;
}
#details .tab-item {
  flex: 1;
  max-width: 280px;
  text-align: center;
  padding: 16px 0;
  font-size: 15px;
  font-weight: 500;
  color: #8a7f97;
  cursor: pointer;
  transition: all .2s;
  border-bottom: 3px solid transparent;
}
#details .tab-item:hover {
  color: #ff5f8f;
  background: #fbf5f7;
}
#details .tab-item.active {
  color: #ff5f8f;
  font-weight: 600;
  border-bottom-color: #ff5f8f;
  background: #fbf5f7;
}

/* 商品详情图片 */
#details .detail-imgs {
  margin-top: 24px;
}
#details .detail-imgs img {
  width: 100%;
  max-width: 1225px;
  display: block;
  margin: 0 auto;
  border-radius: 14px;
}

/* ===== 404 ===== */
#details .not-found {
  height: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #b9afc5;
  gap: 12px;
}
#details .not-found i {
  font-size: 48px;
  color: #d5cddb;
}

@media (max-width: 900px) {
  #details .details-main {
    flex-direction: column;
    padding: 0 12px;
  }
  #details .details-gallery {
    flex: none;
    width: 100%;
    position: static;
  }
  #details .gallery-card img,
  #details .gallery-card .single-img img {
    height: 360px;
  }
  #details .content-card {
    padding: 20px;
  }
  #details .props-card {
    grid-template-columns: 1fr;
  }
  #details .action-row {
    flex-direction: column;
  }
  #details .btn-fav {
    width: 100%;
  }
  #details .brand-header-title {
    max-width: 260px;
    font-size: 14px;
  }
  #details .nav-item {
    font-size: 12px;
    padding: 4px 8px;
  }
  #details .detail-imgs img {
    border-radius: 0;
  }
}
</style>
